import React from 'react';
import { getColor, includeTextStyles } from 'legacylib/theme/utils';
import styled from 'styled-components';
import { Student } from 'core/models/user-manager';

const AccessCellWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  @media screen and (max-width: 549px) {
    color: ${getColor('textSecondary')};
    margin-bottom: 4px;
  }

  svg {
    margin-right: 8px;
    width: 12px;
    height: 12px;
    color: ${getColor('green500')};
    &.red {
      color: ${getColor('red500')};
    }
  }

  /* We'll make this button look like a link */
  button {
    ${includeTextStyles('body')};
    cursor: pointer;
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    text-decoration: underline;
    color: ${getColor('textSecondary')};
    &:hover {
      color: ${getColor('teal600')};
    }
  }
`;

export const AccessDot = ({ fullAccess }: { fullAccess: boolean }) => {
  return (
    <svg viewBox="0 0 10 10" className={`${fullAccess ? 'green' : 'red'}`}>
      <circle cx="5" cy="5" r="5" fill="currentColor"></circle>
    </svg>
  );
};

export const StudentAccessCell = ({ student }: { student: Student }) => {
  const { accessDescription, fullAccess } = student;

  return (
    <AccessCellWrapper>
      <AccessDot fullAccess={!!fullAccess} />
      {accessDescription}
    </AccessCellWrapper>
  );
};
